import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {AuthService} from "../../../services/auth.service";
import {DarkModeService} from "../../../services/dark-mode.service";
import {Router} from "@angular/router";
import {StorageService} from "../../../services/storage.service";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store";
import {Observable} from "rxjs";
import {
  LanguageTranslation
} from "../../../store/entities/system-configurations/language-translation/language-translation.model";
import {AuthUserProfile} from "../../../store/entities/uaa/auth-user.model";
import {TranslateService} from "@ngx-translate/core";
import {selectStoreItems} from "../../../store/entities/store-item/store-item.selectors";
import {StoreItemEntity} from "../../../store/entities/store-item/store-item.model";

@Component({
  selector: 'app-guest-top-bar',
  templateUrl: './guest-top-bar.component.html',
  styleUrl: './guest-top-bar.component.scss'
})
export class GuestTopBarComponent implements OnInit{


  authService = inject(AuthService);
  darkModeService: DarkModeService = inject(DarkModeService)
  private router: Router = inject(Router);
  private storageService: StorageService = inject(StorageService);
  store: Store<AppState> = inject(Store<AppState>)

  languages$: Observable<LanguageTranslation[]>
  @Input() currentState: 'openState' | 'closeState' = 'closeState';
  @Input() isDrawable: boolean = false;
  @Output() drawerToggle = new EventEmitter<any>();
  activeLang: string = 'English';
  activeLightMode: 'light' | 'night' = 'light'
  authUser: AuthUserProfile


  isLightMode: boolean;



  private translate: TranslateService = inject(TranslateService);


  ngOnInit() {
    this.activeLightMode = this.darkModeService.isDarkMode ? 'night' : 'light';
    this.isLightMode = this.activeLightMode === 'light';
    // this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
    //   query: GET_ALL_LANGUAGE,
    //   entity: StoreItemEntity.activeLanguage,
    //   filtering: {}
    // }))
    this.languages$ = this.store.select(selectStoreItems(StoreItemEntity.activeLanguage));
  }


  toggleTheme() {
    this.activeLightMode = this.isLightMode ? 'light' : 'night';
    this.darkModeService.toggleDarkMode()
  }

  toggleState() {
    this.drawerToggle.emit()
  }

  changeLanguage(language: 'sw' | 'en'): void {
    this.translate.use(language);
    localStorage.setItem('lang', language);
  }
}
